import styled from "styled-components";

interface HomeButtonProps {
  onClick: () => void;
  scale: number;
}

export const HomeButton = ({ onClick, scale }: HomeButtonProps) => {
  return (
    <Container onClick={onClick} $scale={scale}>
      <img src="images/home.svg" alt="home" width="100%" />
    </Container>
  );
};

const Container = styled.div<{ $scale: number }>`
  transform: scale(${props => props.$scale});
  cursor: pointer;
  pointer-events: all;
  width: 26px;
  height: 26px;
  display: none;
  align-items: center;
  justify-content: center;

  img {
    width: 130%;
    object-fit: contain;
    pointer-events: none;
  }

  @media (orientation: portrait) {
    display: flex;
    width: 8vw;
    height: 8vw;
    transform: scale(1);
  }
`;
